import Select2RemoteMixin from '../../mixins/select2_remote_mixin.js.coffee'

KCVS.Views.IceboxRowsTable =
  store: KCVS.Stores.ReportRowsStore
  template: JST['report_rows/icebox_rows_table']()

  mounted: ->
    @$store.dispatch('fetchIceboxRows')

  data: ->
    addToReportModalOpen: false
    projectPartnerReportPeriodId: null
    processing: false

  computed:
    applicable_sum: ->
      _.reduce(@rows, ((memo, row)-> memo + parseFloat row.applicable_amount), 0.00)

    rows: ->
      @$store.state.iceboxRows

    pprpUrl: ->
      "/admin/project_partners/#{@$store.state.projectPartnerId}/project_partner_report_periods?for_select=true"

    allRowsSelected:
      get: ->
        @$store.state.selectedIceboxRowIds.length == @$store.state.iceboxRows.length
      set: (val) ->
        if val
          @$store.commit('selectAllIceboxRows')
        else
          @$store.commit('deselectAllIceboxRows')

    showMoveFromIceboxButton: ->
      @$store.state.selectedIceboxRowIds.length > 0

  methods:
    openModal: ->
      @addToReportModalOpen = true

    closeModal: ->
      @addToReportModalOpen = false

    moveFromIcebox: ->
      return if @processing # don't run request twice if button is quickly pressed more than once
      @processing = true
      @$store.dispatch('moveSelectedRowsFromIcebox', @projectPartnerReportPeriodId)
      .then(() =>
        @projectPartnerReportPeriodId = null
        @closeModal()
      )

    moveFromIcebox: ->
      @$store.dispatch('moveSelectedRowsFromIcebox', @projectPartnerReportPeriodId)
      .then(() => @closeModal())

  components:
    periodSelect: Select2RemoteMixin
    'informative-tooltip': KCVS.Views.InformativeTooltip
